export function removeMask(data: string): string {
    return data?.replace(/\D/g, ''); // Remove todos os caracteres que não são dígitos
}

/**
 * Remove a máscara de um documento (CPF/CNPJ) preservando letras maiúsculas, pois
 * o CNPJ alfanumérico (RFB, jul/2026) admite A-Z nas 12 primeiras posições.
 * Use em campos de CNPJ ou CPF/CNPJ misto — não em campos numéricos (telefone, CEP).
 */
export function removeDocumentMask(data: string): string {
    return data?.toUpperCase().replace(/[^0-9A-Z]/g, '');
}
